export const DropIcon = 'https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/dropIcon/dropIcon.svg';
// export const Info_Yellow = 'https://olaelectricvideos.blob.core.windows.net/olaelectric-videos/configs-static/assets/images/info-yellow.svg';
export const Info_Yellow = 'https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/images/warn-circle-red.svg';


export const SuccessIcon = 'https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/accessoryOrderSuccess/sucess-icon.svg';
export const offlinepaymentLogo = "https://assets.olaelectric.com/olaelectric-videos/august_15_th_video/pay_at_exp.svg"
export const Tick = 'https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/privacyCheckBox/tick.svg';
